export const API = process.env.REACT_APP_API;

export const API_TOKEN = process.env.REACT_APP_API_TOKEN;

export const API_KEY = process.env.REACT_APP_API_KEY;
